import ProjectLastActivityComponent from './project-last-activity.component'

export default ProjectLastActivityComponent
